import React from "react";

import useButtonLoader from "hooks/useButtonLoader";
import { CustomModal } from "components/modals/ModalBox";
import { useState } from "react";
import { toastMessage } from "utils/toastMessage";

import { addCategory, imgUploadToCloud } from "services/category";

import imgUploadToCloudFun from "components/modals/imgUploadAndGetUrl";
import { ImagePreview } from "utils/imagePreviewURLConverter";

const AddCat = ({
  addCategoryModalState,
  catDataFetchApiCall,
  closeModel,
  catTab,
}) => {
  const [error, setError] = useState({});

  // console.log("error, error message:-", error);

  const [buttonLoader, setButtonLoader] = useButtonLoader("Add");

  //   image detail holder

  const [imgInputState, setImageInputState] = useState("");

  const [imgPreviewState, setImgPreviewState] = useState(null);

  // ------------ cat name holder
  const [catNameState, setCatNameState] = useState("");
  const [typesToComponent, setTypesToComponent] = useState([]);

  // Input Validation
  const validation = () => {
    let status = true;
    let errorObject = {};

    if (!imgInputState.length) {
      errorObject["imgEmptyErrorMsg"] = "Image is not Set";
      status = false;
    }

    if (!catNameState.length) {
      errorObject["categoryName"] = "Category Name is not Set";
      status = false;
    }

    setError(errorObject);

    return status;
  };

  // Add Banner close modal
  const addBannerCloseModal = () => {
    setImageInputState("");

    setTypesToComponent([]);
    setCatNameState("");
    catDataFetchApiCall();
    setError({});
    closeModel();
  };

  // Add Banner handler

  const addCatHandler = async (e) => {
    e.preventDefault();
    if (validation()) {
      setButtonLoader(true);
      try {
        const dataToSend = {
          image: imgInputState,
          name: catNameState,
          description: catNameState,
          type: catTab,
        };

        typesToComponent.includes("isSummer")
          ? (dataToSend["isSummer"] = true)
          : (dataToSend["isSummer"] = false);
        typesToComponent.includes("isWinter")
          ? (dataToSend["isWinter"] = true)
          : (dataToSend["isWinter"] = false);
        typesToComponent.includes("isRainy")
          ? (dataToSend["isRainy"] = true)
          : (dataToSend["isRainy"] = false);

        const { data } = await addCategory(dataToSend);
        // console.log();
        if (data?.status === 200 || data.code === 200) {
          catDataFetchApiCall();
          toastMessage(data?.message, "success", "addCategory");
          addBannerCloseModal();
        }
      } catch (e) {
        console.log("Error:", e.message);
      } finally {
        setButtonLoader(false);
      }
    }
  };

  const imgUploadFunction = async (e) => {
    if (!e?.target?.files[0]?.type.includes("image/")) {
      setError((stateProp) => ({
        ...stateProp,
        imgErrorOccur: "Please Choose Image file not others",
      }));
    } else {
      try {
        const data = await imgUploadToCloudFun(e?.target?.files[0]);
        // console.log("1st data?.data[0]:-------->", data?.data[0]);
        if (data?.status === 200) {
          //   console.log("2nd-------data?.data[0]:-------->", data?.data[0]);
          setImgPreviewState(e?.target?.files[0]);
          setImageInputState(data?.data[0]);
        }
      } catch (error) {
        console.log("error while uploading and getting data", error);
      }
    }
  };

  return (
    <CustomModal
      className={"add_model"}
      show={addCategoryModalState}
      handleClose={addBannerCloseModal}
    >
      <h3>Add Category</h3>
      {/* ---------input tag name */}
      <div className="form_field">
        <label htmlFor="cat-name" className="label">
          Category Name
        </label>{" "}
        <input
          className="input form-control"
          type="text"
          id="cat-name"
          onChange={(e) => {
            setCatNameState(e.target.value);
          }}
          maxLength={50}
        />
        {error["categoryName"] && (
          <p className="error">{error["categoryName"]}</p>
        )}
      </div>

      <div className="form_field">
        <label className="label">Upload Category logo (237px × 378px)</label>
        <input
          onChange={imgUploadFunction}
          type="file"
          accept="image/*"
          className="form-control input"
        />

        {!imgInputState.length && error["imgEmptyErrorMsg"] && (
          <span className="error">{error["imgEmptyErrorMsg"]}</span>
        )}
        {error["imgErrorOccur"] && (
          <p className="error">{error["imgErrorOccur"]}</p>
        )}

        {/* ------image preview Container div */}
        <div className="image_preview">
          {<ImagePreview file={imgPreviewState} />}
        </div>
      </div>
      <div className="form_field">
        <label className="label">Category Type</label>

        <CatTypeComponent setTypesToComponent={setTypesToComponent} />
      </div>

      {/* ---------Category name and its types */}

      <div className="cat-name-and-type-container">
        <div className="cat-type-main-container"></div>
      </div>

      <div className="button_wrap">
        <button
          type="button"
          className="button light"
          onClick={addBannerCloseModal}
        >
          Cancel
        </button>
        <button
          type="button"
          ref={buttonLoader}
          onClick={addCatHandler}
          className="button"
        >
          Submit
        </button>
      </div>
    </CustomModal>
  );
};

export default AddCat;

const CatTypeComponent = ({ setTypesToComponent }) => {
  const [data, setData] = useState([]);

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;

    if (checked) {
      setTypesToComponent((prev) => [...prev, value]);
    } else {
      setTypesToComponent((prev) => prev.filter((item) => item !== value));
    }

    // sendToCatComponent(data);
  };

  return (
    <div className="select_list">
      <label>
        <input
          type="checkbox"
          name="days"
          value="isSummer"
          onChange={handleCheckboxChange}
        />
        Shop By Summary Category
      </label>

      <label>
        <input
          type="checkbox"
          name="days"
          value="isWinter"
          onChange={handleCheckboxChange}
        />
        Shop By Winter Category
      </label>

      <label>
        <input
          type="checkbox"
          name="days"
          value="isRainy"
          onChange={handleCheckboxChange}
        />
        Shop By Rainy Category
      </label>

      <br />
      {/* <button onClick={handleSubmit}>Submit</button> */}
    </div>
  );
};
